<template>
  <div class="global-toast-message">
    <v-alert
      v-model="alert"
      outlined
      transition="fade-transition"
      elevation="9"
      :type="toastType"
      min-width="300"
      dismissible
      close-icon="mdi-close"
      data-testid="global-toast-message"
    >
      <div>
        <span
          v-html="toastMessage"
          :class="{ title: titleClass }"
          data-testid="global-toast-msg"
        ></span>
      </div>
      <span v-html="toastMessageLineTwo" v-if="toastMessageLineTwo != ''">
      </span>
      <template v-if="toastDownloadLink != ''">
        <a
          :href="toastDownloadHref"
          rel="noopener"
          @click.prevent="onToastDownloadLinkClick"
          >{{ $t('global.clickHere') }}</a
        >
      </template>
      <template v-if="toastLink != ''">
        <router-link
          :to="{ name: toastLink.route, params: { id: toastLink.id } }"
          class="white-link"
          @click.native="viewCaseClick"
        >
          {{ $t('case.viewCase') }}
        </router-link>
      </template>
    </v-alert>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapState, mapActions } from 'vuex'
import { VIEW_CASE_CLICK } from '@/constants/mixpanelEvents'

export default defineComponent({
  name: 'GlobalToastMessage',
  data() {
    return {}
  },
  computed: {
    ...mapState('ToastMessage', [
      'toastMessage',
      'showToastMessage',
      'toastType',
      'toastLink',
      'toastMessageLineTwo',
      'toastDownloadLink',
    ]),
    titleClass() {
      if (this.toastMessageLineTwo) return true
      else return false
    },
    isToastDownloadActionLink() {
      return String(this.toastDownloadLink || '').startsWith('action:')
    },
    toastDownloadHref() {
      if (this.isToastDownloadActionLink) return '#'
      return this.toastDownloadLink
    },
    alert: {
      get() {
        return this.showToastMessage
      },
      set(oldValue, newValue) {
        if (!newValue) this.callCloseToast()
      },
    },
  },
  methods: {
    ...mapActions('ToastMessage', ['callCloseToast']),
    onToastDownloadLinkClick() {
      const link = String(this.toastDownloadLink || '')
      if (!link) return

      if (this.isToastDownloadActionLink) {
        window.dispatchEvent(
          new CustomEvent('toast-download-link-click', {
            detail: link,
          })
        )
        this.callCloseToast()
        return
      }

      window.open(link, '_blank', 'noopener')
    },
    viewCaseClick() {
      this.$mixpanelUserTrack(VIEW_CASE_CLICK)
    },
  },
})
</script>

<style lang="scss">
.global-toast-message {
  @media only screen and (max-width: 600px) {
    .v-alert {
      top: 70px !important;
      right: 20px !important;
    }
  }
  .v-alert {
    position: fixed;
    top: 70px;
    right: 150px;
    z-index: 300;
    background-color: $color-veryDarkBackground !important;
    &::before {
      background-color: $color-veryDarkBackground;
      opacity: 0;
    }
    .v-alert__icon {
      margin: auto;
      padding-right: 12px;
    }
    .v-alert__dismissible {
      margin-right: -12px;
    }
    .white-link {
      color: #fff;
      font-weight: 800;
    }
    .v-icon {
      height: 32px;
      width: 32px;
    }
    .title {
      font-size: 1.15rem !important;
      font-weight: 600;
    }
  }
}
</style>
